<template>
  <div>
    <div class="header">
      <div class="logo">
        <div class="logo_left">
          <img src="../../assets/jpg/posReport.png" alt />
          <!-- <p>FAMILY OF CONSUMER COMPANIES</p> -->
        </div>
        <div class="logo_right" @click="showMsg(flag)">
          <p style="margin-top: 5px">
            <van-icon name="warning-o" />
          </p>
          <p>查看说明</p>
        </div>
      </div>
      <div class="nav">
        <div class="tian" @click="change" :class="{ isActive: flag }">
          <p>{{ Title1 }}</p>
          <span>Report</span>
        </div>
        <div class="pos" @click="change" :class="{ isActive: !flag }">
          <p>{{ Title2 }}</p>
          <span>Report</span>
        </div>
      </div>
      <div class="msg" v-show="showMsgFlag" v-if="flag">
        <div class="sanjiao sanjiao1"></div>
        <p>更新时间说明：{{ upMsg1 }}</p>
        <span>渠道说明:{{ upMsg2 }}</span>
        <p>其他说明:{{ upMsg3 }}</p>
        <span>用户服务:{{ upMsg4 }}</span>
        <van-icon
          name="close"
          color="#fff"
          size="24px"
          style="position: absolute; right: 5%; top: 33%"
          @click="showMsg"
        />
      </div>
      <div class="msg" v-show="showMsgFlag" v-else>
        <div class="sanjiao sanjiao2"></div>
        <p>更新时间说明：{{ hisMsg1 }}</p>
        <span>渠道说明:{{ hisMsg2 }}</span>
        <p>其他说明:{{ hisMsg3 }}</p>
        <span>用户服务:{{ hisMsg4 }}</span>

        <van-icon
          name="close"
          color="#fff"
          size="24px"
          style="position: absolute; right: 5%; top: 33%"
          @click="showMsg"
        />
      </div>
    </div>

    <div class="container" id="container">
      <MyMask ref="change"></MyMask>
      <!-- 公告栏 -->

      <!-- <van-overlay :show="show" z-index="99999">
        <div class="wrapper" @click.stop>
          <div class="block">
            <h4 style="margin: 30px auto 10px; font-weight: bold;">公告</h4>
            <p
              style="color: rgb(121, 121, 121); font-size: 16px; padding: 5px 10px; line-height: 26px; margin: -3px auto 18px; display: block; width: 85%;"
            >{{messageTie}}</p>
            <van-button
              size="large"
              block
              style="border-radius: 0px 0px 8px 8px; height: 52px; line-height: 52px;"
              @click="show = false"
            >
              <span>
                <p style="color: rgb(103, 109, 143); font-size: 18px; margin-top: -10px;">
                  <b>我知道了</b>
                </p>
              </span>
            </van-button>
          </div>
        </div>
      </van-overlay> -->

      <!-- <keep-alive> -->
      <transition>
        <ButThrAll v-if="flag"></ButThrAll>
        <ButThrHis v-else></ButThrHis>
      </transition>
      <!-- </keep-alive> -->
    </div>
  </div>
</template>
<script>
import MyMask from "@/components/public/mask";
import ButThrAll from "@/components/ButThr/ButThr_all";
import ButThrHis from "@/components/ButThr/ButThr_History";
import qs from "qs";

export default {
  name: "index",
  data() {
    return {
      show: false,
      messageTie: "十月数据预计将于10/12开始更新，敬请谅解!",
      active: 0,
      flag: true,
      Title1: "当前月",
      Title2: "历史月",
      upMsg1: "本报告于每周一更新",
      upMsg2: "当前月报告更新天猫+京东销售额",
      upMsg3: "本报告基于强生月进行更新",
      upMsg4: "如有任何建议,请在公众号进行回复并留下邮箱",
      hisMsg1: "本报告于每强生月C+13进行更新",
      hisMsg2: "历史月报告更新全线上渠道销售额",
      hisMsg3: "本报告基于强生月进行更新",
      hisMsg4: "如有任何建议,请在公众号进行回复并留下邮箱",
      showMsgFlag: false,
    };
  },
  methods: {
    getMsgNotice(){

       this.$addr
        .post("Log/getNotice",qs.stringify({menuId:'3'})).then((res)=>{

            if(res.data.data.isEffective==1){
            this.show=true
          this.messageTie=res.data.data.notice

          }else{
             this.show=false
          }
        })
    },
    sendTime(menu) {
      var time = new Date();
      var y = time.getFullYear();
      var m = (time.getMonth() + 1).toString().padStart(2, "0");
      var d = time.getDate().toString().padStart(2, "0");
      var h = time.getHours().toString().padStart(2, "0");
      var mm = time.getMinutes().toString().padStart(2, "0");
      var s = time.getSeconds().toString().padStart(2, "0");
      var EndTime = `${y}-${m}-${d} ${h}:${mm}:${s}`;
      const sendEnd = {
        startDate: EndTime,
        endDate: "",
        wwid: JSON.parse(sessionStorage.getItem("userInfo")).wwid,
        name: JSON.parse(sessionStorage.getItem("userInfo")).name,
        menu: "EC-Pos Report",
        operationModule: menu,
      };
      this.$addr.post("Log/insert", qs.stringify(sendEnd)).then((res) => {});
    },
    change() {
      this.flag = !this.flag;
      if (this.flag == true) {
        this.sendTime(this.Title1);
      } else {
        this.sendTime(this.Title2);
      }
      sessionStorage.setItem("longFlag", this.longFlag);
      this.$refs.change.loadFun();
      this.longFlag = !this.longFlag;
    },
    getUserInfo() {
      if (sessionStorage.userInfo != undefined) {
        const user = JSON.parse(sessionStorage.userInfo);
        this.name = user.name;
        this.wwid = user.wwid;
      } else {
        this.$router.push({ path: "/" });
      }
    },
    showMsg(tit) {
      this.showMsgFlag = !this.showMsgFlag;
    },
    getTimeGone() {
      this.$addr.get("weekly/getTimeGone").then((res) => {
        sessionStorage.setItem("achVing2", res.data.data);
      });
    },
  },
  components: {
    MyMask,
    ButThrAll,
    ButThrHis,
  },
  created() {
    this.getMsgNotice()
    this.sendTime(this.Title1);
    this.getTimeGone();
    this.getUserInfo();
  },
  beforeRouteLeave(to, from, next) {
    var time = new Date();
    var y = time.getFullYear();
    var m = (time.getMonth() + 1).toString().padStart(2, "0");
    var d = time.getDate().toString().padStart(2, "0");
    var h = time.getHours().toString().padStart(2, "0");
    var mm = time.getMinutes().toString().padStart(2, "0");
    var s = time.getSeconds().toString().padStart(2, "0");
    var EndTime = `${y}-${m}-${d} ${h}:${mm}:${s}`;
    const sendEndObj = {
      startDate: "",
      endDate: EndTime,
      wwid: JSON.parse(sessionStorage.getItem("userInfo")).wwid,
      name: JSON.parse(sessionStorage.getItem("userInfo")).name,
      menu: "EC-Pos Report",
    };
    this.$addr.post("Log/insert", qs.stringify(sendEndObj)).then((res) => {
      next();
    });
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
* {
  box-sizing: border-box;
}
.sanjiao {
  position: absolute;
  top: -29px;
  width: 0;
  height: 0;
  border-width: 15px;
  border-style: solid;
  border-color: transparent transparent rgba(0, 0, 0, 0.5) transparent;
}
.sanjiao2 {
  right: 25%;
}
.sanjiao1 {
  left: 25%;
}
.msg {
  position: relative;
  width: 100%;
  background: rgba(0, 0, 0, 0.5);
  min-height: 70px;
  z-index: 99;
  padding: 10px 0 10px 32px;
  margin-bottom: 20px;
}
.msg p,
span {
  font-family: "PingFangSC-Medium";
  font-size: 12px;
  color: #ffffff;
  line-height: 25px;
}
body {
  width: 100%;
  background-image: linear-gradient(
    -1deg,
    #eeeeee 22%,
    rgba(237, 237, 237, 0.98) 93%,
    rgba(216, 216, 216, 0) 100%
  );
  min-height: 100%;
  position: relative;
  /* box-sizing: border-box; */
}
.header {
  position: relative;
  padding-top: 35px;
  top: 0;
  z-index: 99;
  background-image: url("../../assets/jpg/bgkenvue.png");
   background-repeat: no-repeat;
  background-size: 100%;
  width: 100%;
  min-height: 185px;
  box-sizing: border-box;
  overflow: hidden;
}
.logo {
  display: flex;
  align-items: center;
  justify-content: space-around;
  margin-left: 35px;
  height: 35px;
  width: 100%;
  margin-bottom: 20px;
}
.logo_left {
  margin-left: -30px;
}
.logo .logo_left img {
  width: 280px;
  margin-bottom: 0.2%;
}
.wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
}

.block {
  width: 350px;
  min-height: 40px;
  line-height: 40px;
  background-color: #fff;
  text-align: center;
  font-size: 20px;
  border-radius: 8px;
}
.logo_right {
  padding: 4px;
  display: flex;
  /* flex-direction: column; */
  align-items: center;
  justify-content: space-around;
  background: #B1E0DA;
  box-shadow: 0 2px 10px 0 #b03e37;
  border-radius: 14.5px;
  width: 90px;
  height: 30px;
  margin-right: 40px;
}
.logo_right p {
  font-family: "PingFangSC-Medium";
  font-size: 14px;
  color: #01B198;
}

.nav {
  width: 380px;
  height: 60px;
  margin: 0 auto;
  margin-bottom: 20px;
  border: 2px solid #ffffff;
  border-radius: 30px;
  box-shadow: inset -5px 0 20px 0 #912a23;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.nav .isActive {
  background: #ffffff;
  box-shadow: 5px 0 20px 0 #912a23;
  border-radius: 30px;
  height: 60px;
  color: #01B198 !important;
}
.nav .isActive span {
  color: #01B198 !important;
}
.nav .tian,
.nav .pos {
  font-family: "PingFangSC-Medium";
  font-size: 15px;
  text-align: center;
  line-height: 20px;
  padding: 10px 36px;
  color: #ffffff;
  min-width: 185px;
}
.container {
  position: relative;
  width: 100%;
  height: 100%;
  background: #f6f6ff;
  box-shadow: inset 0 2px 10px 0 rgba(0, 0, 0, 0.5);
  border-radius:0  0 20px 20px;
 overflow: hidden;

}
</style>



// WEBPACK FOOTER //
// src/components/ButThr/ButThr_Index.vue